module.exports = __webpack_public_path__ + "static/fipcwhiterabbit3-a9646fe9f5a817615ae3acd3402bdb7e.jpeg";